import React, { Fragment } from 'react';
import { db } from '../../utils/firebase';
import EditQuestion from '../../components/Surveys/EditQuestion';
import SearchDialog from '../../components/SearchDialog';
import QSetSearchDialog from '../../components/QSetSearchDialog';
import { array_move, checkQuestion, isAttributeUnique, checkLogicArray } from '../../utils/miscFunctions';
import AlertDialog from '../../components/AlertDialog';
import ErrorDialog from '../../components/ErrorDialog';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import _ from 'lodash';
import logger from '../../logger';

import QuestionContext from '../../QuestionContext';
import { withSurveyContext } from '../../SurveyContext';
import LogicDialog from '../../components/Surveys/LogicDialog';
import ErrorBoundary from '../../components/ErrorBoundary';
import VaultApiRequestService from '../../VaultApiRequestService';
import ComboBox from '../../components/Autocomplete';
import { isResponseOkay } from '../../utils/miscFunctions';

const menuItems = [
    { value: 'new', label: 'Add new question' },
    { value: 'existing', label: 'Add existing question' },
    { value: 'set', label: 'Add question set' },
    { value: 'welcome_screens', label: 'Welcome Screen' },
    { value: 'thankyou_screens', label: 'Thank You Screen' },
]

const languages = [
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Spanish' },
    { value: 'ru', label: 'Russian' },
    { value: 'ch', label: 'Chinese' },
    { value: 'fr', label: 'French' },
    { value: 'tl', label: 'Tagalog' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'ar', label: 'Arabic' },
    { value: 'so', label: 'Somali' },
    { value: 'ko', label: 'Korean' }
]

const requiredValidation = [
    'email',
    'long_text',
    'short_text',
    'multiple_choice',
    'opinion_scale',
    'phone_number',
    'yes_no'
]

const styles = {
    'form-container': {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '60%',
        marginBottom: 30,
    },
    'label': {
        fontSize: 20,
        marginBottom: 0,
        textTransform: 'capitalize',
        color: '#0256c5',
        paddingLeft: 1 + "rem"
    },
    'input': {
        backgroundColor: 'white',
        border: 'none',
        borderBottom: '2px solid #B8D0EF',
        outline: 'none',
        width: '100%',
        fontSize: 1 + "rem",
        fontWeight: 'regular',
        lineHeight: 1.6,
        marginBottom: 15,
        boxShadow: 'none',
        boxSizing: 'border-box',
        borderRadius: "4px 4px 0 0",
    },
    'button': {
        borderRadius: 8,
        margin: 10,
        width: '70%',
    },
    'select': {
        fontSize: 16,
        width: '50%',
        margin: 3,
        height: 40
    }
}

class CreateSurvey extends React.Component {
    constructor(props) {
        super(props);
        const { surveyContext } = this.props;
        this.state = {
            id: this.props.match.params.id,
            title: '',
            language: 'en',
            fields: [],
            question_sets: [],
            logic: [],
            openQuestionSearch: false,
            openQSetSearch: false,
            openSnackbar: false,
            snackbarMessage: '',
            anchorEl: null,
            openAlert: false,
            alertText: '',
            alertTitle: '',
            alertType: '',
            openError: false,
            errorTitle: '',
            errorDetails: [],
            welcome_screens: null,
            disabledQuestions: [],
            thankyou_screens: [{ id: "DefaultTyScreen", ref: 'default_tys', properties: { show_button: false, share_icons: false }, title: 'Done! Your information was sent perfectly.' }],
            monitorFields: [
                "latitude", "longitude", "source"
            ],
            currentLogicQuestion: null,
            customers: surveyContext?.customers || [],
            selectedCustomer: '',
            campaigns: [],
            filteredCampaigns: [],
            selectedCampaign: '',
            loading: false
        }
        this.fieldRefs = [];
    }
    async componentDidUpdate(prevProps) {
        const { surveyContext } = this.props;
        if (!_.isEqual(surveyContext?.customers, prevProps.surveyContext?.customers)) {
            this.setState({
                customers: surveyContext?.customers || []
            }, () => this.loadCampaigns());
        }
    }

    async componentDidMount() {
        this.setState({ loading: true });
        this.loadCampaigns();
        db.collection("question_sets").onSnapshot(querySnapshot => {
            const question_sets = querySnapshot.docs.map(doc => doc.data());
            this.setState({
                question_sets: question_sets
            });
        });
        if (this.state.id) {
            console.log("Duplicating existing survey")
            let data = await fetch(`/.netlify/functions/typeform?type=getSingle&uid=${this.state.id}`).then(response =>
                response.json()
            ).catch(err => console.log(err));
            if (data && data.status >= 200 && data.status < 300) {
                let fields = data.message.fields ? data.message.fields.map(field => {
                    let question = {
                        title: field.title,
                        ref: field.ref,
                        validations: field.validations,
                        properties: field.properties,
                        type: field.type
                    }
                    if (field.type === 'multiple_choice') {
                        question.properties.choices = field.properties.choices.map(choice => {
                            return { label: choice.label }
                        })
                    }
                    return question;
                }) : [];
                let welcome_screens = data.message.welcome_screens ? data.message.welcome_screens.map(screen => {
                    return {
                        ref: screen.ref,
                        title: screen.title,
                        properties: screen.properties
                    }
                }) : null;
                let thankyou_screens = data.message.thankyou_screens ? data.message.thankyou_screens.map(screen => {
                    return {
                        ref: screen.ref,
                        title: screen.title,
                        properties: screen.properties
                    }
                }) : null;
                this.setState({
                    title: "Copy of " + data.message.title,
                    language: data.message.settings.language,
                    fields: fields,
                    thankyou_screens: thankyou_screens,
                    welcome_screens: welcome_screens,
                    logic: data.message.logic ? data.message.logic : [],
                    disabledQuestions: data.message.fields ? fillDisabled(data.message.fields.length) : [],
                });
            } else {
                console.log("Error retrieving survey with that ID");
            }
        } else {
            console.log("Creating new survey")
        }
        this.setState({ loading: false });
    }

    loadCampaigns = () => {
        const { customers } = this.state;
        const campaigns = [];
        customers.forEach(customer => {
            if (!customer.campaigns) return;
            customer.campaigns.forEach(campaign => {
                if (campaign.is_active) {
                    campaigns.push({ ...campaign, customerId: customer.id });
                }
            });
        });
        this.setState({
            campaigns,
            filteredCampaigns: campaigns
        });
    }

    filterCampaignsByCustomer = (customer) => {
        console.log('Filtering campaigns', customer?.id);
        let filteredCampaigns = [...this.state.campaigns];
        if (customer?.id) {
            filteredCampaigns = filteredCampaigns.filter(campaign => campaign.customerId === customer.id);
        }
        this.setState({
            filteredCampaigns,
            selectedCampaign: ''
        });
    }

    updateSelectedCustomerBySelectedCampaign = (inputCampaign) => {
        if (!(inputCampaign?.id)) return;

        try {
            let foundCustomer = this.state.customers.find(customer => customer.id === inputCampaign.customerId);
            if (foundCustomer) {
                this.setState({
                    selectedCustomer: foundCustomer
                });
            }
        } catch (err) {
            console.error(err);
        }
    }

    toggleQuestionSearch = () => {
        this.setState({
            openQuestionSearch: !this.state.openQuestionSearch
        });
    }

    toggleError = () => {
        this.setState({
            openError: !this.state.openError
        });
    }

    handleFormChange = (value, field) => {
        this.setState({
            [field]: value
        }, () => {
            if (field === 'selectedCustomer') {
                this.filterCampaignsByCustomer(value);
            } else if (field === 'selectedCampaign') {
                this.updateSelectedCustomerBySelectedCampaign(value);
            }
        });
    }

    handleAddScreen = (screen) => {
        let dataCopy;
        let newScreen = {
            title: "",
            ref: "",
            properties: {}
        }
        if (screen === 'welcome_screens') {
            if (this.state.welcome_screens) {
                this.setState({
                    snackbarMessage: "Couldn't add welcome screen. Welcome screen already exists...",
                    openSnackbar: true
                })
                return;
            }
            dataCopy = [newScreen];
        } else {
            if (this.state.thankyou_screens.length > 1) {
                this.setState({
                    snackbarMessage: "Couldn't add thank you screen. Thank you screen already exists...",
                    openSnackbar: true
                })
                return;
            }
            dataCopy = [...this.state[screen]];
            dataCopy.unshift(newScreen);
        }
        this.setState({
            [screen]: dataCopy
        });
    }

    handleDeleteScreen = (screen) => {
        let dataCopy;
        if (screen === 'welcome_screens') {
            dataCopy = null;
        } else {
            dataCopy = [...this.state[screen]];
            dataCopy.splice(0, 1);
        }
        this.setState({
            [screen]: dataCopy
        });
    }

    handleScreenChange = (value, path, screen, idx) => {
        let dataCopy = [...this.state[screen]];
        _.set(dataCopy[idx], path, value);
        this.setState({
            [screen]: dataCopy
        });
    }

    addQuestion = () => {
        let dataCopy = [...this.state.fields];
        dataCopy.push({
            title: '',
            ref: '',
            type: 'yes_no',
            validations: { required: true },
            properties: {}
        });
        let newDisabled = [...this.state.disabledQuestions, false];
        this.setState({
            fields: dataCopy,
            disabledQuestions: newDisabled
        });
    }

    deleteQuestion = (idx) => {
        let dataCopy = [...this.state.fields];
        dataCopy.splice(idx, 1);
        let newDisabled = [...this.state.disabledQuestions];
        newDisabled.splice(idx, 1);
        this.setState({
            fields: dataCopy,
            disabledQuestions: newDisabled
        });
    }

    onRowClick = (data) => {
        let dataCopy = [...this.state.fields];
        let clonedData = _.cloneDeep(data);
        let newQuestion = {
            title: clonedData.title,
            ref: clonedData.ref,
            type: clonedData.type,
            properties: clonedData.properties
        }
        if (data.type !== 'group' && data.type !== 'statement') {
            newQuestion.validations = { required: true }
        }
        if (data.type === 'multiple_choice') {
            newQuestion.properties.choices = newQuestion.properties.choices.map(choice => {
                return { label: choice.label }
            })
        }
        dataCopy.push(newQuestion);
        let newDisabled = [...this.state.disabledQuestions, true];
        this.setState({
            fields: dataCopy,
            disabledQuestions: newDisabled,
            openQuestionSearch: false,
        });
    }

    toggleQSetSearch = () => {
        this.setState({
            openQSetSearch: !this.state.openQSetSearch
        });
    }

    onQSetClick = (data) => {
        console.log("Adding question set: ", data);
        let newQuestions = [];
        let notFoundRefs = [];
        const questions = this.context;
        const newRefs = data.fields;
        const newDisabled = [...this.state.disabledQuestions];
        newRefs.forEach(ref => {
            let found_question = questions.find(q => q.ref === ref && q.language === this.state.language);
            if (found_question) {
                let clonedFound = _.cloneDeep(found_question);
                let newQuestion = {
                    title: clonedFound.title,
                    ref: clonedFound.ref,
                    type: clonedFound.type,
                    properties: clonedFound.properties
                }
                if (found_question.type !== 'group') {
                    newQuestion.validations = { required: true }
                }
                if (found_question.type === 'multiple_choice') {
                    newQuestion.properties.choices = newQuestion.properties.choices.map(choice => {
                        return { label: choice.label }
                    })
                }
                newQuestions.push(newQuestion);
                newDisabled.push(true);
            } else {
                notFoundRefs.push(ref);
            }
        });
        if (newQuestions.length > 0) {
            let dataCopy = [...this.state.fields, ...newQuestions];
            this.setState({
                fields: dataCopy,
                disabledQuestions: newDisabled
            });
        }
        if (notFoundRefs.length > 0) {
            let alertText = "The following questions were not found in this survey's language: ";
            notFoundRefs.forEach((ref, idx) => {
                if (idx !== notFoundRefs.length - 1) {
                    alertText = alertText + ref + ', ';
                } else {
                    alertText = alertText + ref;
                }
            });
            this.setState({
                openAlert: true,
                alertTitle: "Some questions were not found",
                alertText: alertText,
                alertType: 'question_set'
            })
        }
        this.setState({
            openQSetSearch: false
        });
    }

    handleFieldPositionChange = (oldIdx, newIdx) => {
        let newFields = array_move(this.state.fields, oldIdx, newIdx);
        let newDisabled = array_move(this.state.disabledQuestions, oldIdx, newIdx);
        this.setState({
            fields: newFields,
            disabledQuestions: newDisabled
        });
    }

    toggleSnackbar = () => {
        this.setState({
            openSnackbar: !this.state.openSnackbar
        });
    }

    toggleDisabled = (idx) => {
        let dataCopy = [...this.state.disabledQuestions];
        dataCopy[idx] = !this.state.disabledQuestions[idx];
        this.setState({
            disabledQuestions: dataCopy
        });
    }

    handleSaveEdits = (idx, value) => {
        let dataCopy = [...this.state.fields];
        if (!checkQuestion(value, this.context, this.state.language)) {
            this.setState({
                openSnackbar: true,
                snackbarMessage: `Data for  ${idx + 1}. ${value.ref} does not match database. Change the ref if you would like to save the edits. Press the undo button to cancel edits.`
            })
            return;
        } else if (_.isEqual(dataCopy[idx], value)) {
            this.setState({
                openSnackbar: true,
                snackbarMessage: `No changes were made to question ${idx + 1}. ${value.ref}.`
            });
        } else {
            dataCopy[idx] = value;
            this.setState({
                fields: dataCopy,
                openSnackbar: true,
                snackbarMessage: `Successfully edited question ${idx + 1}. ${value.ref}.`
            });
        }
        this.toggleDisabled(idx);
    }

    addLogicJump = (logicIdx, type, fieldRef) => {
        let dataCopy = [...this.state.logic];
        let newAction = {
            action: "jump",
            details: {
                to: {
                    type: "thankyou",
                    value: "default_tys"
                }
            },
            condition: {
                op: "is",
                vars: [
                    { type: 'field', value: fieldRef },
                ]
            }
        }
        if (type === 'multiple_choice') {
            newAction.condition.vars.push({ type: 'choice', value: null });
        } else if (type === 'yes_no') {
            newAction.condition.vars.push({ type: 'constant', value: true });
        }
        if (logicIdx === -1) {
            let newLogic = {
                type: "field",
                ref: fieldRef,
                actions: [newAction]
            }
            dataCopy.push(newLogic);
        } else if (dataCopy[logicIdx].actions.some(action => action.condition.op === 'always')) {
            dataCopy[logicIdx].actions.splice(-2, 0, newAction);
        } else {
            dataCopy[logicIdx].actions.push(newAction);
        }
        this.setState({
            logic: dataCopy
        })
    }

    handleDeleteLogic = (logicIdx, idx) => {
        let dataCopy = [...this.state.logic];
        dataCopy[logicIdx].actions.splice(idx, 1);
        if (dataCopy[logicIdx].actions.length === 0) {
            dataCopy.splice(logicIdx, 0);
        }
        this.setState({
            logic: dataCopy
        });
    }

    setLogicJumpTo = (value, logicIdx, idx) => {
        let dataCopy = [...this.state.logic];
        dataCopy[logicIdx].actions[idx].details.to.value = value;
        const thankyou = this.state.thankyou_screens.some((e) => e.ref === value);
        if (thankyou) {
            dataCopy[logicIdx].actions[idx].details.to.type = "thankyou";
        } else {
            dataCopy[logicIdx].actions[idx].details.to.type = "field";
        }
        this.setState({
            logic: dataCopy
        });
    }

    setLogicYesNo = (value, logicIdx, idx) => {
        let dataCopy = [...this.state.logic];
        dataCopy[logicIdx].actions[idx].condition.vars[1] = {
            type: 'constant',
            value: value
        }
        this.setState({
            logic: dataCopy
        })
    }

    setLogicChoice = (choiceIdx, field, logicIdx, idx) => {
        let dataCopy = [...this.state.logic];
        let choice = field.properties.choices[choiceIdx];
        let choiceRef = choice.ref;
        if (!choiceRef) {
            let fieldCopy = [...this.state.fields];
            choiceRef = `${field.ref}_${choiceIdx}`;
            fieldCopy[this.state.currentLogicQuestion].properties.choices[choiceIdx].ref = choiceRef;
            this.setState({
                fields: fieldCopy
            });
        }
        dataCopy[logicIdx].actions[idx].condition.vars[1] = {
            type: 'choice',
            value: choiceRef
        }
        this.setState({
            logic: dataCopy
        });
    }

    setLogicOp = (value, logicIdx, idx) => {
        let dataCopy = [...this.state.logic];
        dataCopy[logicIdx].actions[idx].condition.op = value;
        this.setState({
            logic: dataCopy
        });
    }

    addLogicAlwaysJump = (value, logicIdx) => {
        let dataCopy = [...this.state.logic];
        const alwaysAction = {
            action: "jump",
            condition: {
                op: "always",
                vars: []
            },
            details: {
                to: {
                    type: "field",
                    value: value
                }
            }
        }
        const thankyou = this.state.thankyou_screens.some((e) => e.ref === value);
        if (thankyou) {
            alwaysAction.details.to.type = "thankyou";
        };
        dataCopy[logicIdx].actions.push(alwaysAction);
        this.setState({
            logic: dataCopy
        });
    }

    validateForm = () => {
        const { fields, disabledQuestions } = this.state;
        let isRefUnique = isAttributeUnique(fields, 'ref');
        let editing = disabledQuestions.find(q => q === false);
        if (editing !== undefined) {
            this.setState({
                snackbarMessage: "Save or cancel all edits before updating the survey.",
                openSnackbar: true
            });
            return false;
        } else if (!isRefUnique) {
            this.setState({
                snackbarMessage: "Error creating survey: multiple fields with the same ref.",
                openSnackbar: true
            });
            return false;
        }
        return true;
    }

    getQuestions = () => {
        const { fields } = this.state;
        let questions = [];
        fields.forEach(field => {
            let question = {
                'ref': field.ref,
                'title': field.title,
                'properties': field.properties,
                'type': field.type
            }
            if (requiredValidation.includes(field.type)) {
                question.validations = field.validations;
            }
            if (field.type === 'group') {
                question.properties.fields = removeIdsFromGroup(field.properties.fields);
            }
            questions.push(question);
        });
        return questions;
    }
    
    getData = (questions) => {
        const { title, language, monitorFields, welcome_screens,
                thankyou_screens, logic, fields } = this.state;
        let data = {
            'title': title,
            'settings': {
                'language': language,
                'is_public': true,
                show_typeform_branding: false
            },
            'hidden': monitorFields,
            'fields': questions,
            "workspace": {
                "href": `https://api.typeform.com/workspaces/${process.env.REACT_APP_ACTIVE_WORKSPACE}`
            },
        }
        if (welcome_screens) {
            data.welcome_screens = welcome_screens;
        }
        if (thankyou_screens > 0) {
            data.thankyou_screens = thankyou_screens[0];
        }
        if (logic.length > 0) {
            let allFields = [...fields];
            if (welcome_screens) {
                allFields = allFields.concat(welcome_screens);
            }
            if (thankyou_screens) {
                allFields = allFields.concat(thankyou_screens);
            }
            data.logic = checkLogicArray(logic, allFields);
        }
        console.log(data);
        return data;
    }

    handleErrorOnVault = () => {
        this.setState({
            snackbarMessage: "Error creating survey in Vault",
            openSnackbar: true
        });
        setTimeout(() => {
            // Redirect to the page containing the add survey button
            this.props.history.push(`/surveys`);
        }, 3000);
    }

    createNewSurveyInVault = async (typeFormResponse) => {
        try {
            const { surveyContext } = this.props;
            const vaultResponse = await VaultApiRequestService.createNewSurvey(
                typeFormResponse.message, this.state.selectedCampaign.id
            );
            if (!vaultResponse?.data) {
                logger.exception(
                    'Error creating survey in Vault',
                    _.get(vaultResponse, 'message'),
                    { 
                        payload: _.pick(typeFormResponse.message, ['id', 'hidden', 'settings.language', 'title']),
                        campaign: this.state.selectedCampaign.id
                    }
                );
                this.handleErrorOnVault();
            } else {
                await surveyContext.updateContext();
                this.props.history.push(`/surveys/${typeFormResponse.message.id}`);
            }
        } catch (err) {
            logger.error(err, { 
                action: 'Create survey in vault',
                campaign: this.state.selectedCampaign.id,
                payload: _.pick(typeFormResponse.message, ['id', 'hidden', 'settings.language', 'title'])
            });
            this.handleErrorOnVault();
        }
    }

    createTypeform = async () => {
        this.setState({ loading: true });
        const valid = this.validateForm();
        if (!valid) {
            this.setState({ loading: false });
            return;
        }
        const questions = this.getQuestions();
        const data = this.getData(questions);
        let response;
        try {
            response = await fetch(`/.netlify/functions/typeform?type=create`, {
                body: JSON.stringify(data),
                method: 'POST'
            });
            response = await response.json();
        } catch (err) {
            logger.error(err, { action: 'Create survey in Typeform', payload: data });
        }
        if (isResponseOkay(response)) {
            await this.createNewSurveyInVault(response);
        } else if (response) {
            logger.exception(
                'Error creating survey in Typeform',
                '',
                { 
                    description: _.get(response, 'message.description'),
                    details: _.get(response, 'message.details'),
                    payload: data,
                }
            );
            this.setState({
                errorTitle: `${response.status}: ${response.message.description}`,
                errorDetails: response.message.details ? response.message.details : [],
                openError: true
            });
        } else {
            logger.exception(
                'Error creating survey in Typeform',
                '',
                { payload: data }
            );
            this.setState({
                snackbarMessage: "Error creating survey..",
                openSnackbar: true
            });
            console.log("Error creating form!!!");
        }
    }

    handleMenuClick(option) {
        if (option === 'new') {
            this.addQuestion();
        } else if (option === 'existing') {
            this.toggleQuestionSearch();
        } else if (option === 'thankyou_screens' || option === 'welcome_screens') {
            this.handleAddScreen(option);
        } else if (option === 'set') {
            this.toggleQSetSearch();
        }
        this.setState({
            anchorEl: null
        })
    }

    scrollToQuestion(idx) {
        window.scrollTo(0, this.fieldRefs[idx].offsetTop);
    }

    render() {
        const { title, monitorFields, fields, language, customers, filteredCampaigns, selectedCustomer, selectedCampaign, welcome_screens, thankyou_screens, anchorEl, openSnackbar, snackbarMessage, openQuestionSearch,
            logic, currentLogicQuestion, question_sets, openQSetSearch, openAlert, alertTitle, alertText, openError, errorTitle, errorDetails, loading } = this.state;
        let openLogic = (currentLogicQuestion !== null) ? true : false;
        return (
            <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                <h2 style={{ textAlign: 'center' }}> Survey Creator </h2>
                <Button style={{ position: 'absolute', left: 10, top: 0, margin: 0 }} color="secondary" variant='outlined' onClick={() => this.props.history.goBack()}> Back</Button>
                <hr />
                <div style={{ display: 'flex', width: '100%', height: '100%' }}>
                    <div style={{ width: '25%', height: '90vh', overflow: 'scroll', top: 0, position: 'sticky', padding: 10 }}>
                        <h3>Survey Overview</h3>
                        <hr />
                        {monitorFields &&
                            <Fragment>
                                <h3> Hidden Fields: </h3>
                                {monitorFields.map(hf => (
                                    <p key={hf} style={{ margin: 2 }}>{hf}</p>
                                ))}
                            </Fragment>
                        }
                        <h3> Fields: </h3>
                        <ol style={{ paddingLeft: 20, paddingRight: 20 }}>
                            {fields.map((field, idx) => (
                                <li key={idx} style={{ cursor: 'pointer', margin: 10 }} onClick={() => this.scrollToQuestion(idx)}>
                                    {field.ref}
                                    {field.type === 'group' &&
                                        field.properties.fields &&
                                        <ol type="a" style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}>
                                            {field.properties.fields.map((field, fieldIdx) => (
                                                <li key={fieldIdx} style={{ marginBottom: 8 }}> {field.ref} </li>
                                            ))}
                                        </ol>
                                    }
                                </li>
                            ))}
                        </ol>
                    </div>
                    <div style={styles['form-container']}>
                        <label style={styles["label"]} htmlFor="title">title</label>
                        <input
                            id="title"
                            type="text"
                            value={title}
                            onChange={(e) => this.handleFormChange(e.target.value, "title")}
                            required
                            style={styles["input"]}
                            autoComplete="off"
                        />
                        <>
                            <label style={styles["label"]} htmlFor="customer">Customer</label>
                            <ComboBox
                                initialValue={selectedCustomer}
                                options={selectedCustomer && selectedCampaign ? [] : customers}
                                title="No customer selected"
                                handleOnChange={(customer) => this.handleFormChange(customer, "selectedCustomer")}
                            />
                            <label style={styles["label"]} htmlFor="campaign">Campaign</label>
                            <ComboBox
                                initialValue={selectedCampaign}
                                options={filteredCampaigns}
                                title="No campaign selected"
                                handleOnChange={(campaign) => this.handleFormChange(campaign, "selectedCampaign")}
                            />
                        </>
                        <label style={styles["label"]} htmlFor="language">Language</label>
                        <select id="language" value={language} onChange={(e) => this.handleFormChange(e.target.value, "language")} style={styles["select"]}>
                            {languages.map(language => {
                                return (
                                    <option key={language.value} value={language.value}> {language.label} </option>
                                )
                            })}
                        </select>
                        {welcome_screens &&
                            <div style={{ width: '80%', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                                <IconButton style={{ position: 'absolute', right: 20 }} onClick={() => this.handleDeleteScreen("welcome_screens")}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                                <h4>Welcome Screen</h4>
                                <label style={styles["label"]} htmlFor="welcome-title">Welcome Screen Text </label>
                                <input
                                    id="welcome-title"
                                    style={styles["input"]}
                                    value={welcome_screens[0]["title"]}
                                    onChange={(e) => this.handleScreenChange(e.target.value, 'title', 'welcome_screens', 0)}
                                    autoComplete="off"
                                />
                                <label style={styles["label"]} htmlFor="welcome-ref">Welcome Screen Ref </label>
                                <input
                                    id="welcome-ref"
                                    style={styles["input"]}
                                    value={welcome_screens[0]["ref"]}
                                    onChange={(e) => this.handleScreenChange(e.target.value, 'ref', 'welcome_screens', 0)}
                                    autoComplete="off"
                                />
                                <label style={styles["label"]} htmlFor="welcome-desc">Welcome Screen Description</label>
                                <input
                                    id="welcome-desc"
                                    style={styles["input"]}
                                    value={welcome_screens[0]['properties']["description"] ? this.state.welcome_screens[0]['properties']["description"] : ''}
                                    onChange={(e) => this.handleScreenChange(e.target.value, 'properties.description', 'welcome_screens', 0)}
                                    autoComplete="off"
                                />
                            </div>
                        }
                        {this.state.fields.map((field, idx) => {
                            return (
                                <div style={{ width: '100%' }} key={idx} ref={fieldRef => this.fieldRefs[idx] = fieldRef}>
                                    <ErrorBoundary>
                                        <EditQuestion
                                            field={field}
                                            idx={idx}
                                            deleteQuestion={this.deleteQuestion}
                                            handleFieldPositionChange={this.handleFieldPositionChange}
                                            isGroupItem={false}
                                            label={`${idx + 1}.`}
                                            fields={this.state.fields}
                                            disabled={this.state.disabledQuestions[idx]}
                                            toggleDisabled={this.toggleDisabled}
                                            handleSaveEdits={this.handleSaveEdits}
                                            language={this.state.language}
                                            handleFormChange={this.handleFormChange}
                                            logic={this.state.logic}
                                        />
                                    </ErrorBoundary>
                                    <hr />
                                </div>
                            )
                        })}
                        {thankyou_screens.length > 1 &&
                            <div style={{ width: '80%', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                                <IconButton style={{ position: 'absolute', right: 20 }} onClick={() => this.handleDeleteScreen("thankyou_screens")}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                                <h4>Thank You Screen</h4>
                                <label style={styles["label"]} htmlFor="thankyou-title">Thank You Screen Text </label>
                                <input
                                    id="thankyou-title"
                                    style={styles["input"]}
                                    value={thankyou_screens[0]["title"]}
                                    onChange={(e) => this.handleScreenChange(e.target.value, 'title', 'thankyou_screens', 0)}
                                    autoComplete="off"
                                />
                                <label style={styles["label"]} htmlFor="thankyou-ref">Thank You Screen Ref </label>
                                <input
                                    id="thankyou-ref"
                                    style={styles["input"]}
                                    value={thankyou_screens[0]["ref"]}
                                    onChange={(e) => this.handleScreenChange(e.target.value, 'ref', 'thankyou_screens', 0)}
                                    autoComplete="off"
                                />
                            </div>
                        }
                        <Button variant='outlined' color='primary' style={{ width: '40%', margin: 10, borderRadius: 8 }}
                            aria-controls="new-question-menu" aria-haspopup="true"
                            onClick={(e) => this.handleFormChange(e.currentTarget, 'anchorEl')}
                            disabled={loading}
                        >
                            Add New Field </Button>
                        <Menu
                            id="new-question-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={() => this.handleFormChange(null, 'anchorEl')}
                            style={{ zIndex: 10 }}
                        >
                            {menuItems.map((option) => {
                                return (
                                    <MenuItem
                                        key={option.value}
                                        onClick={(event) => this.handleMenuClick(option.value)}
                                    >
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Menu>
                        <Button variant='outlined' color='primary' style={styles["button"]} onClick={this.createTypeform} disabled={!title || loading || !selectedCampaign}> Create Typeform </Button>
                    </div>
                </div>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={openSnackbar}
                    autoHideDuration={5000}
                    onClose={this.toggleSnackbar}
                    message={snackbarMessage}
                    style={{ fontSize: 14 }}
                />
                {this.context &&
                    <SearchDialog
                        data={this.context}
                        open={openQuestionSearch}
                        toggleOpen={this.toggleQuestionSearch}
                        onRowClick={this.onRowClick}
                        languageFilter={language}
                    />
                }
                {this.state.question_sets &&
                    <QSetSearchDialog
                        data={question_sets}
                        open={openQSetSearch}
                        toggleOpen={this.toggleQSetSearch}
                        onRowClick={this.onQSetClick}
                    />
                }
                {(this.state.currentLogicQuestion !== null) &&
                    <LogicDialog
                        open={openLogic}
                        toggleOpen={() => this.handleFormChange(null, "currentLogicQuestion")}
                        logic={logic}
                        field={fields[currentLogicQuestion]}
                        fields={fields}
                        welcome_screens={welcome_screens}
                        thankyou_screens={thankyou_screens}
                        position={currentLogicQuestion}
                        handleDelete={this.handleDeleteLogic}
                        setChoice={this.setLogicChoice}
                        setYesNo={this.setLogicYesNo}
                        setOp={this.setLogicOp}
                        setJumpTo={this.setLogicJumpTo}
                        addLogicJump={this.addLogicJump}
                        addAlwaysJump={this.addLogicAlwaysJump}
                    />
                }
                <AlertDialog
                    open={openAlert}
                    title={alertTitle}
                    text={alertText}
                    noClick={() => this.handleFormChange(false, 'openAlert')}
                />
                <ErrorDialog
                    open={openError}
                    title={errorTitle}
                    details={errorDetails}
                    noClick={this.toggleError}
                />
            </div>
        )
    }
};

CreateSurvey.contextType = QuestionContext;

function removeIdsFromGroup(fields) {
    return fields.map(field => {
        let newField = {
            properties: field.properties,
            ref: field.ref,
            title: field.title,
            type: field.type
        }
        if (field.type === 'multiple_choice') {
            newField.properties.choices = field.properties.choices.map(choice => {
                return { label: choice.label }
            })
        }
        if (requiredValidation.includes(field.type)) {
            newField.validations = field.validations;
        }
        return newField;
    })
};

function fillDisabled(length) {
    let disabled = [];
    let i;
    for (i = 0; i < length; i++) {
        disabled.push(true);
    }
    return disabled;
}

export default withSurveyContext(CreateSurvey);
